import { z } from 'zod';

export const patchrightVersionSchema = z.string().regex(/^\d+\.\d+\.\d+$/);
export const browserRuntimeReleaseSchema = z.object({
  id: z.string().uuid(),
  patchrightVersion: patchrightVersionSchema,
  browserVersion: z.string().min(1).max(200),
});
export const browserUpdateStateSchema = z.object({
  id: z.string().uuid().nullable(),
  status: z.enum(['idle', 'running', 'succeeded', 'rolled_back', 'rollback_failed']),
  phase: z.string(),
  activeRelease: browserRuntimeReleaseSchema.nullable(),
  previousRelease: browserRuntimeReleaseSchema.nullable(),
  logs: z.array(z.string()),
  revision: z.number().int().nonnegative(),
  startedAt: z.string().nullable(),
  finishedAt: z.string().nullable(),
});
